import { rhodolite } from "@latticexyz/common/chains";
import { anvil } from "./anvil";

const params = new URLSearchParams(window.location.search);
export const chainId = Number(params.get("chainId") || params.get("chainid") || import.meta.env.VITE_CHAIN_ID || 31337);

export const supportedChains = [anvil, rhodolite] as const;

const chain = supportedChains.find((c) => c.id === chainId)!;
if (!chain) {
  throw new Error("Unsupported chain: " + chainId);
}

export { chain };
